// extracted by mini-css-extract-plugin
export default {"label-holder":"label-holder-4f66","center-text":"center-text-efc0","breadcrumb-link":"breadcrumb-link-bc15","title":"title-11b6","bold":"bold-a8ea"};